var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E86610",
    strokeWidth: 1.5,
    d: "M.75 10.508v-3.29m0 0V1.3l5.513 3.183z"
  })));
};
export default SvgFlag;